import { createSlice } from "@reduxjs/toolkit";

const initialLinkState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    linkForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const linkSlice = createSlice({
    name: "links",
    initialState: initialLinkState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getLinkById
        linkFetched: (state, action) => {
            state.actionsLoading = false;
            state.linkForEdit = action.payload.linkForEdit;
            state.floorPlans = action.payload.linkForEdit.floorPlans;
            state.error = null;

        },
        // getLinkChart
        linkChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.linkChart = action.payload.linkChart;
            state.error = null;

        },
        // getLinkChart
        linkHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.linkChartHour = action.payload.linkChartHour;
            state.error = null;

        },
        // getLinkChart
        linkHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.linkChartHourZone = action.payload.linkChartHourZone;
            state.error = null;

        },
        // get list data
        linksFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.linkForEdit = undefined;
            state.floorPlans = undefined;
            state.linkChart = undefined;
            state.linkChartHour = undefined;
            state.linkChartHourZone = undefined;
        },
        // createLink
        linkCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateLink
        linkUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // linkDeleted
        linkDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
